import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  IconHome,
  IconArrowLeft,
  IconAlertTriangle,
  IconServerOff,
  IconCircleX
} from '@tabler/icons-react';

const ErrorPage = ({ code = 404, title, message, showHomeButton = true }) => {
  const location = useLocation();
  
  // Автоопределение ошибки из state или параметров
  const errorCode = location.state?.code || code;
  const errorTitle = location.state?.title || title;
  const errorMessage = location.state?.message || message;

  const errors = {
    400: {
      icon: IconCircleX,
      title: 'Неверный запрос',
      message: 'Запрос содержит ошибку. Проверьте введенные данные.',
      color: 'text-amber-400'
    },
    401: {
      icon: IconAlertTriangle,
      title: 'Требуется авторизация',
      message: 'Для доступа к этой странице необходимо войти в систему.',
      color: 'text-amber-400'
    },
    403: {
      icon: IconAlertTriangle,
      title: 'Доступ запрещен',
      message: 'У вас нет прав для просмотра этой страницы.',
      color: 'text-red-400'
    },
    404: {
      icon: IconAlertTriangle,
      title: 'Страница не найдена',
      message: 'Запрашиваемая страница не существует или была удалена.',
      color: 'text-primary-500'
    },
    500: {
      icon: IconServerOff,
      title: 'Ошибка сервера',
      message: 'Произошла внутренняя ошибка сервера. Мы уже работаем над её устранением.',
      color: 'text-red-400'
    },
    502: {
      icon: IconServerOff,
      title: 'Сервер недоступен',
      message: 'Не удалось связаться с сервером. Попробуйте обновить страницу позже.',
      color: 'text-red-400'
    },
    503: {
      icon: IconServerOff,
      title: 'Сервис временно недоступен',
      message: 'Сервис находится на техническом обслуживании. Скоро вернемся!',
      color: 'text-amber-400'
    }
  };

  const error = errors[errorCode] || errors[404];
  const Icon = error.icon;

  return (
    <div className="min-h-screen bg-dark-950 flex items-center justify-center px-6 pt-32 pb-20">
      <div className="max-w-lg w-full">
        {/* Основной блок ошибки */}
        <div className="rounded-2xl border border-dark-800 bg-dark-900 p-10 text-center">
          {/* Иконка */}
          <div className="flex justify-center mb-6">
            <div className={`w-16 h-16 rounded-xl ${error.color === 'text-primary-500' ? 'bg-primary-500/10' : error.color === 'text-red-400' ? 'bg-red-500/10' : 'bg-amber-500/10'} flex items-center justify-center`}>
              <Icon className={`w-8 h-8 ${error.color}`} />
            </div>
          </div>

          {/* Код ошибки */}
          <div className={`text-6xl font-bold ${error.color} mb-4`}>
            {errorCode}
          </div>

          {/* Заголовок */}
          <h1 className="text-2xl font-bold text-white mb-3">
            {errorTitle || error.title}
          </h1>

          {/* Описание */}
          <p className="text-dark-500 mb-8 max-w-md mx-auto">
            {errorMessage || error.message}
          </p>

          {/* Кнопки действий */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
            <button
              onClick={() => window.history.back()}
              className="flex items-center gap-2 px-6 py-3 rounded-lg border border-dark-800 bg-dark-850 text-white hover:border-dark-700 transition-colors"
            >
              <IconArrowLeft className="w-4 h-4" />
              <span>Назад</span>
            </button>

            {showHomeButton && (
              <Link
                to="/"
                className="flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-semibold transition-colors"
              >
                <IconHome className="w-4 h-4" />
                <span>На главную</span>
              </Link>
            )}
          </div>
        </div>

        {/* Дополнительная информация */}
        <div className="mt-6 text-center">
          <p className="text-dark-500 text-sm">
            Если проблема повторяется, свяжитесь с{' '}
            <a
              href="https://t.me/XNCsup_bot"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-500 hover:text-primary-400 underline"
            >
              Telegram поддержкой
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
